// import React, { useState } from "react";
// import AnimateCC from "react-adobe-animate";

import * as React from "react";
import { useState } from "react";
import Script from "next/script";

import { AnimateCC, GetAnimationObjectParameter } from "react-adobe-animate";

const Hw4 = () => {
  const [paused, setPaused] = useState(true);
  const [animationObject, getAnimationObject] = useState<GetAnimationObjectParameter|null>(null);
  const onClick = () => setPaused(!paused);

  console.log(animationObject);

  return (
    <div style={{ width: "400px" }}>
      <AnimateCC
        animationName="lishtml5"
        getAnimationObject={getAnimationObject}
        paused={paused}
      />

      <AnimateCC
        animationName="lishtml5"
        composition="C1475B64B160904BB90B34246A5FF54B"
        paused={paused}
      />

      <button onClick={onClick}>{paused ? "Unpause" : "Pause"}</button><br />
    </div>
  );
};

//  render(<Hw2></Hw2>, document.querySelector('#root'));
export default Hw4;
